import { Box, Flex } from '@chakra-ui/react';

export interface SegmentOption<T extends string | number> {
  value: T;
  label: string;
}

export interface SegmentedControlProps<T extends string | number> {
  value: T;
  onChange: (value: T) => void;
  options: SegmentOption<T>[];
}

/**
 * Figma-styled segmented control (the "Editable · Vector · Image" tab row).
 * A dark track with a raised pill on the selected segment.
 */
export function SegmentedControl<T extends string | number>({
  value,
  onChange,
  options,
}: SegmentedControlProps<T>) {
  return (
    <Flex
      bg="figma.bgDark"
      borderWidth="1px"
      borderColor="figma.border"
      borderRadius="md"
      p="1"
      gap="1"
    >
      {options.map((option) => {
        const selected = option.value === value;
        return (
          <Box
            as="button"
            key={String(option.value)}
            flex="1"
            onClick={() => onChange(option.value)}
            py="1.5"
            px="2"
            borderRadius="sm"
            fontSize="sm"
            fontWeight="500"
            bg={selected ? 'figma.panelHover' : 'transparent'}
            color={selected ? 'figma.text' : 'figma.textSecondary'}
            boxShadow={selected ? 'sm' : 'none'}
            transition="all 0.15s"
            {...(selected ? {} : { _hover: { color: 'figma.text' } })}
          >
            {option.label}
          </Box>
        );
      })}
    </Flex>
  );
}
